import type { MissionCategory, MissionDifficulty } from '@/state/types';

/**
 * Phase 14 Hot-Fix — Filter-Defaults für `MissionsTab`. Eigenes Modul, damit
 * der Component-File ausschließlich Komponenten exportiert (sonst meckert
 * `react-refresh/only-export-components`).
 *
 * Vor diesem Fix fehlte `'police'` in `categories`, was dazu führte, dass die
 * Liste leer blieb, obwohl der Bell-Counter (Phase 13.11) Polizei-Missions
 * mitzählte. Symptom: Karte zeigt Marker, Tab zeigt nichts.
 */
export interface MissionFilters {
  statuses: Set<'active' | 'closed' | 'failed'>;
  categories: Set<MissionCategory>;
  difficulties: Set<MissionDifficulty>;
}

export const ALL_MISSION_CATEGORIES: MissionCategory[] = [
  'fire',
  'rescue',
  'technical',
  'police',
];

export const DEFAULT_FILTERS: MissionFilters = {
  statuses: new Set(['active']),
  categories: new Set<MissionCategory>(ALL_MISSION_CATEGORIES),
  difficulties: new Set<MissionDifficulty>(['easy', 'medium', 'hard', 'expert', 'extreme']),
};
